// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikSelect } from "src/components/Forms/Select";
import { types } from "src/constants/account";
import { FormikProps } from "formik";
import ClearButton from "./ClearButton";
import { Box } from "src/components/Core/Box";

interface Props {
  formProps: FormikProps<any>;
  clearFilterKey: (key: string) => void;
}

const Platform: React.FC<Props> = ({ formProps, clearFilterKey }) => {
  let platform = formProps?.values?.accountType;
  let isVisible = false;
  let backgroundColor = "#FFFFFF";

  if (platform !== "") {
    isVisible = true;
    backgroundColor = "#FAFAFA";
  }
  return (
    <Box background={backgroundColor} padding="5px">
      <Field
        label="Platform:"
        mb={20}
        extra={
          <ClearButton
            isVisible={isVisible}
            buttonClick={() => {
              formProps?.setFieldValue("accountType", "");
              clearFilterKey("accountType");
            }}
          />
        }
      >
        <FormikSelect
          name="accountType"
          data={types}
          local
          borderRadius={3}
          borderColor="grey5"
          size="middle"
        />
      </Field>
    </Box>
  );
};

export default Platform;
